import { gql } from '@apollo/client';

export const bodyCompMutations = {
  CONFIRM_BODY_COMP_QC: gql`
    mutation confirmBodyCompQC($studyId: String!) {
      confirmBodyCompQC(studyId: $studyId) {
        message
        statusCode
      }
    }
  `,
};

export const { CONFIRM_BODY_COMP_QC } = bodyCompMutations;

export const documentMutations = {
  CREATE_DOCUMENT: gql`
    mutation createDocument($document: DocumentInput!) {
      createDocument(document: $document) {
        uuid
      }
    }
  `,
  DEACTIVATE_DOCUMENT: gql`
    mutation deactivateDocument(
      $studyId: String
      $carePlanId: String
      $careActivityId: String
      $typeId: UUID!
    ) {
      deactivateDocument(
        studyId: $studyId
        carePlanId: $carePlanId
        careActivityId: $careActivityId
        typeId: $typeId
      ) {
        uuid
      }
    }
  `,
  UPDATE_DOCUMENT: gql`
    mutation updateDocument($document: DocumentUpdate!) {
      updateDocument(document: $document) {
        uuid
        status
      }
    }
  `,
};

export const { CREATE_DOCUMENT, DEACTIVATE_DOCUMENT, UPDATE_DOCUMENT } = documentMutations;
